import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { NavigationModule } from '../navigation.module';

import { NgrxNavigationComponent } from './ngrx-navigation.component';
import { NgrxNavigationEffects } from './ngrx-navigation.effects';

@NgModule({
  declarations: [NgrxNavigationComponent],
  imports: [
    CommonModule,
    NavigationModule,
    EffectsModule.forFeature([NgrxNavigationEffects]),
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: true,
      connectInZone: true,
    }),
  ],
  exports: [NgrxNavigationComponent],
})
export class NgrxNavigationModule {
  static forRoot(): ModuleWithProviders<NgrxNavigationModule> {
    return {
      ngModule: NgrxNavigationModule,
      providers: [Store],
    };
  }
}
